import OfcsObject from './object';

/**
 * Base class for all views
 * @class   Ofcs.View
 * @extends Ofcs.Object
 */
export default class View extends OfcsObject {}
